import { $api } from '#/api/client'

interface IFetchUserNameResponse {
  userName: string
  isLoading: boolean
  isError: boolean
}

export const useFetchUserName = (companyId: string, userId: string): IFetchUserNameResponse => {
  const { data, isLoading, isError } = $api.useQuery(
    'get',
    '/companies/{companyId}/users/{id}',
    {
      params: {
        path: { companyId, id: userId },
      },
    },
    {
      enabled: companyId.length > 0 && userId.length > 0,
      select: (response): string =>
        response.displayName ?? [response.firstName, response.lastName].filter(Boolean).join(' ') ?? '',
    },
  )

  return {
    userName: data ?? '',
    isLoading,
    isError,
  }
}
